export default "__VITE_ASSET__B8W8p5r6__"